import { render, staticRenderFns } from "./SectionRoute.vue?vue&type=template&id=265cbf9b&"
import script from "./SectionRoute.vue?vue&type=script&lang=ts&"
export * from "./SectionRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports